import React from "react";
import { toPersianNum, toSeperatedNum } from "../../assets/utils";
import { MainStyled } from "./reqInfo.styles";
import "../../app/App.css";
const ReqInfo = ({ info }) => {
  let {
    Height,
    Length,
    Width,
    description,
    packaging,
    package_count,
    value,
    weight,
    weight_unit,
    reuqested_date_persian,
    created_date_persian,
    load_type,
    loading_description,
    evacuationFrom,
    evacuationUntil,
    evacuation_description,
    estimate_km,
    estimate_time,
    source_location,
    destination_location,
    more_destinations,
  } = info;
  // console.log("lolo", info);
  return (
    <MainStyled className="reqinfo-details">
      <div className="flex-grow-1 mr-0 my-3 align-self-lg-center">
        <div className="mb-2">
          {reuqested_date_persian ? (
            <div className="border-bottom mb-2">
              <div className="text-muted font-weight-light font-size--n2 mb-1">
                زمان درخواست
              </div>
              <div>{toPersianNum(created_date_persian)}</div>
            </div>
          ) : (
            ""
          )}
          <div className="border-bottom mb-2">
            {reuqested_date_persian ? (
              <div>
                <div className="text-muted font-weight-light font-size--n2 mb-1">
                  زمان بارگیری
                </div>
                <div>{toPersianNum(reuqested_date_persian)}</div>
              </div>
            ) : (
              ""
            )}
            {loading_description ? (
              <div>
                <div className="text-muted font-weight-light font-size--n2 mb-1">
                  توضیحات بارگیری
                </div>
                <div>{loading_description}</div>
              </div>
            ) : (
              ""
            )}
          </div>
          {evacuationFrom && evacuationUntil ? (
            <div className="border-bottom mb-2">
              <div className="text-muted font-weight-light font-size--n2 mb-1">
                بازه تخلیه
              </div>
              <div>
                {`از ${toPersianNum(evacuationFrom)} تا ${toPersianNum(
                  evacuationUntil
                )}`}
              </div>
              {evacuation_description ? (
                <div>
                  <div className="text-muted font-weight-light font-size--n2 mb-1">
                    توضیحات تخلیه
                  </div>
                  <div>{evacuation_description}</div>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="border-bottom mb-2">
          <div className="text-muted font-weight-light font-size--n2 mb-1">
            آدرس مبدا
          </div>
          <div>{source_location ? source_location.detail : "نامشخص"}</div>
          <div className="text-muted font-weight-light font-size--n2 mb-1">
            آدرس مقصد
          </div>
          <div>
            {destination_location ? destination_location.detail : "نامشخص"}
          </div>
          {more_destinations
            ? more_destinations.map((item,index) => (
                <span key={index}>
                  <div className="text-muted font-weight-light font-size--n2 mb-1">
                    آدرس مقصد {index+2}
                  </div>
                  <div>
                    {item
                      ? item.detail
                      : "نامشخص"}
                  </div>
                </span>
              ))
            : ""}
          <div className="text-muted font-weight-light font-size--n2 mb-1">
            مسافت و زمان تقریبی
          </div>
          <div>
            {estimate_km ? estimate_km : "نامشخص"} ،{" "}
            {estimate_time ? estimate_time : "نامشخص"}
          </div>
        </div>
        {load_type ? (
          <div className="border-bottom mb-2">
            <div className="text-muted font-weight-light font-size--n2 mb-1">
              نوع بار
            </div>
            <div>{toPersianNum(load_type.tname)}</div>
          </div>
        ) : (
          ""
        )}
        {packaging & Height && Length && Width ? (
          <div className="border-bottom d-flex align-items-center justify-content-between pb-1 mt-3">
            {packaging ? (
              <div>
                <div className="text-muted font-weight-light font-size--n2 mb-1">
                  بسته بندی
                </div>
                <div>
                  {`${toPersianNum(package_count)} عدد ${toPersianNum(
                    packaging.pname
                  )} `}
                </div>
              </div>
            ) : (
              ""
            )}
            {Height && Length && Width ? (
              <div style={{ textAlign: "left" }}>
                <div className="text-muted font-weight-light font-size--n2 mb-1">
                  طول، عرض و ارتفاع
                </div>
                <div>
                  {Length ? <span> {toPersianNum(Length)} × </span> : null}

                  {Width ? <span> {toPersianNum(Width)} × </span> : null}

                  {Height ? <span> {toPersianNum(Height)} </span> : null}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}

        <div className="border-bottom d-flex align-items-center justify-content-between pb-1 mt-3">
          <div>
            <div className="text-muted font-weight-light font-size--n2 mb-1">
              وزن
            </div>
            <div>
              {weight
                ? `${toPersianNum(weight)} ${
                    weight_unit === "ton"
                      ? "تن"
                      : weight_unit === "kg"
                      ? "کیلوگرم"
                      : null
                  }`
                : "وارد نشده‌است"}
            </div>
          </div>
          <div style={{ textAlign: "left" }}>
            <div className="text-muted font-weight-light font-size--n2 mb-1">
              ارزش
            </div>
            <div>
              {value
                ? `${toSeperatedNum(toPersianNum(value))} تومان`
                : "وارد نشده‌است"}
            </div>
          </div>
        </div>
      </div>
      {description ? (
        <div className="border-bottom mb-2">
          <div className="text-muted font-weight-light font-size--n2 mb-1">
            شرح بار
          </div>
          <div>{description}</div>
        </div>
      ) : (
        ""
      )}
    </MainStyled>
  );
};

export default ReqInfo;
